export const SUPPORT_AI_RUN_EVENT_PAGE_LIMIT = 50;
export const SUPPORT_AI_RUN_MAX_CURSOR = 2_147_483_647;

export function isValidSupportAIRunCursor(value: unknown): value is number {
  return Number.isSafeInteger(value) && Number(value) >= 0 && Number(value) <= SUPPORT_AI_RUN_MAX_CURSOR;
}

export function assertValidSupportAIRunCursor(value: unknown): asserts value is number {
  if (!isValidSupportAIRunCursor(value)) throw new RangeError('Invalid support AI run cursor');
}

type SupportAIRunResource = 'detail' | 'events' | 'stream' | 'cancel' | 'retry';

export function getBoundSupportAIRunUrl(
  value: unknown,
  binding: { origin: string; ticketNumber: string; runId: string; resource: SupportAIRunResource }
) {
  if (typeof value !== 'string' || !value || value.startsWith('//')) return null;
  const suffix: Record<SupportAIRunResource, string> = {
    detail: '',
    events: 'events/',
    stream: 'events/stream/',
    cancel: 'cancel/',
    retry: 'retry/'
  };
  const expectedPath = `/api/support/tickets/${encodeURIComponent(binding.ticketNumber)}/ai/runs/${encodeURIComponent(binding.runId)}/${suffix[binding.resource]}`;
  try {
    const url = new URL(value, binding.origin);
    if (url.origin !== binding.origin || url.pathname !== expectedPath || url.search || url.hash) return null;
    return url.href;
  } catch {
    return null;
  }
}
